import React from 'react'
import { FormattedMessage } from 'react-intl'
import type { IFeatureListGroup } from './interfaces'

const LandingFeatureListGroup: React.FC<IFeatureListGroup> = ({ features, withFeatureTitles, markType }) => {
  return (
    <ul className={`landing-feature-list-group list-with-marks ${markType ? `list-with-marks_with-${markType}` : ''}`}>
      {features.map(({ title, text }, index) => (
        <li className="landing-feature-list-item" key={index}>
          {withFeatureTitles && (
            <div className="landing-feature-list-item__title h4 h5-sm">
              <FormattedMessage id={title} />
            </div>
          )}
          <FormattedMessage id={text} tagName="p" />
        </li>
      ))}
    </ul>
  )
}

export default LandingFeatureListGroup
